const PortfolioData = [
  {
    id: 1,
    name: "LuxuryTrips",
    img: "https://i.ibb.co/fGPntjg/Luxry-Trip.png",
    description:
      "LuxuryTrips - a full stack responsive web app for booking tour. [28th – 30thOctober, 2021] \n\n" +
      "1. App has private route and when user login then he/she see all route.\n" +
      "2. User can see his/her order in My Order page.\n" +
      "3. User can add Trips which on display in the Homepage.\n" +
      "4. User can change customer’s order status.\n\n" +
      " **Tools:** HTML5, CSS3, Tailwind CSS, React, Node.js, Express.js, CRUD operations, MongoDB, Firebase Auth, Axios, React hook Form.\n\n",
    liveLink: "https://tour-planner-45921.web.app/",
    clientSideCode: "https://github.com/Rabbi01521/luxuryTrips-client-side",
    serverSideCode: "https://github.com/Rabbi01521/-luxuryTrips-server-side",
  },
  {
    id: 2,
    name: "Handicraft Shop",
    img: "https://i.ibb.co/b6CXJb3/Handicraft-Shop.png",
    description:
      "Handicraft Shop - a full stack responsive web app for Niche Product Website. [10th – 12th November, 2021] \n\n" +
      "1. Admin can add new services, make new admins and change customer’s order status.\n" +
      "2. Admin can add product that product added in the Collection page.\n" +
      "3. User can give a review which will be displayed on homepage.\n" +
      " **Tools:** HTML5, CSS3, Material UI, React, Node.js, Express.js, CRUD operations, MongoDB, Firebase Auth, React-Router.\n\n",
    liveLink: "https://handicraft-store.web.app/",
    clientSideCode:
      "https://github.com/Rabbi01521/Handicraft-_shop_client-website",
    serverSideCode:
      "https://github.com/Rabbi01521/Handicraft_shop_server_website",
  },
  {
    id: 3,
    name: "Hot Onion",
    img: "https://i.ibb.co/bX0cWfY/React-App.png",
    description:
      "Hot Onion - a full stack responsive web app for selling Foods. [25th – 27st September, 2021] \n\n" +
      "1. User can visit all the page through routing.\n" +
      "2. User selects a product then go to checkout page and place order from there.\n" +
      "3. Order page shows total price to the users and all of his/her orders.\n" +
      " **Tools:** HTML5, CSS3, Tailwind CSS, React, Firebase Auth, localStorage.\n\n",
    liveLink: "https://hot-onion-restaurants-25d3d.web.app/",
    clientSideCode: "https://github.com/Rabbi01521/hot-onion-restaurent",
  },
  {
    id: 4,
    name: "EyeCare Hospital",
    img: "https://i.ibb.co/KG7tvBn/React-App-4.png",
    description:
      "EyeCare Hospital - a responsive front end based on health care web app. [18th – 20st October, 2021]\n\n" +
      "1. App has login and sign up using firebase authentication.\n" +
      "2. App has private route\n" +
      "3. After reloading the page on a private route, the user should not be redirected to the login page.\n" +
      "4. User can see doctors details and disease details in another route if logged in.\n\n" +
      " **Tools:** HTML5, CSS3, Tailwind CSS, ES6, React, Firebase Auth.\n\n",
    liveLink: "https://health-care-hospital-26fd8.web.app/",
    clientSideCode: "https://github.com/Rabbi01521/EyeCare-hospital",
  },
  //   {
  //     id: 5,
  //     name: "LuxuryTrips",
  //     img: "https://i.ibb.co/fGPntjg/Luxry-Trip.png",
  //   },
];

export default PortfolioData;
